import axios from 'axios';
import userSession from 'utils/userSession';

const axiosInstance = () => axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Authorization': `Bearer ${userSession.getDirectMailToken()}`
    }
});

export default axiosInstance;